import { createAction } from '@reduxjs/toolkit';

const deleteCollections = createAction('archive/deleteCollections');

export default deleteCollections;
